<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-hand-grab-o mr-2"></i><strong>Opération Caribou</strong>
      </b-card-header>
      <b-card-body>
        <b-card-text>
          Le script désaffecte tous les dossiers qui sont au statut "A traiter - initialisation", qui ne sont pas affectés à des gestionnaires fictifs ni aux gestionnaires de l'équipe incident, et qui n'ont pas été flagués.
        </b-card-text>
        <div class="row">
          <b-col sm=12>
            <button type="button" size="xl" class="btn btn-danger" @click="desaffectation()"><i class="fa fa-exclamation-triangle"></i> Lancer le script de désaffectation en masse <i class="fa fa-exclamation-triangle"></i></button>
          </b-col>
        </div>
      </b-card-body>
    </b-card>

  </div>
</template>

<script>
  import {isEmpty} from "@/utils/fileHelper";

  export default {
    name: "script_opc_desaffectation_massse",
    data() {
      return {
      }
    },
    watch: {
    },
    created() {
    },
    methods: {
      desaffectation() {
        let self = this;
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: 'Voulez-vous vraiment lancer le script de désaffectation en masse ?',
            type: 'warning',
            reverseButtons: true,
            showCancelButton: true,
            allowOutsideClick: false,
            cancelButtonColor: '#ff1744',
            confirmButtonText: 'Annuler',
            cancelButtonText: 'Désaffectation ne masse'
          })
          .then(result => {
            if (!result.value) {
              this.$store.commit('IS_LOADING', true)
              this.$axios
                .get('/espaceGestion/ocp/desaffectation-masse-ocp')
                .then(response => {
                  this.$store.commit('IS_LOADING', false);
                  let nbDossierDone = !isEmpty(response.data.nbDesaffectation) ? response.data.nbDesaffectation : 0;
                  let nbDossierFind = !isEmpty(response.data.nbDossierFind) ? response.data.nbDossierFind : 0;
                  let htmlSwal = `Désaffectation réalisée avec succès !<br>
                                  Il y a eu ${nbDossierDone} dossiers désaffectés.<br>
                                  Il y a eu ${nbDossierFind} changement de statut`;
                  let typeSwal = 'success';
                  let titleSwal = 'Succès';
                  let timeSwal = 0;
                  self.$swal({
                    position: 'top',
                    type: typeSwal,
                    title: titleSwal,
                    html: htmlSwal,
                    showConfirmButton: false,
                    timer: timeSwal
                  })
                })
                .catch(function (error) {
                  self.$store.commit('IS_LOADING', false)
                  console.log(error)
                  let errorText = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.'
                  if (error.response && error.response.status === 403) {
                    errorText = 'Vous n\'êtes pas autorisé à effectuer cette action'
                  }
                  if (error.response && error.response.status === 424) {
                    errorText = error.response.data.message
                  }
                  self.$swal({
                    position: 'top',
                    type: 'error',
                    title: 'Attention !!',
                    text: errorText,
                    showConfirmButton: false,
                    timer: 5000
                  })
                })
              }
          })
      },
    }
  }
</script>
